import { render } from "./PaywallFooter.vue?vue&type=template&id=17f6be12&scoped=true"
const script = {}

import "./PaywallFooter.vue?vue&type=style&index=0&id=17f6be12&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f6be12"]])

export default __exports__